import { render } from "./ContactModule.vue?vue&type=template&id=21b2225b&scoped=true"
import script from "./ContactModule.vue?vue&type=script&lang=js"
export * from "./ContactModule.vue?vue&type=script&lang=js"

import "./ContactModule.vue?vue&type=style&index=0&id=21b2225b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b2225b"]])

export default __exports__